import { Fragment } from "react";
import styled from "styled-components/macro";
import { Grid, Typography, Checkbox, Slider } from "@mui/material";
import { ToggleOnOutlined, ToggleOffOutlined } from "@mui/icons-material";
import { DesktopDatePicker } from "@mui/x-date-pickers";

import { Autocomplete, Label, Paper, TextField } from "../../../components";
import AutocompleteMultiSelect from "../../../components/MultiselectAutoComplete";
import { set } from "lodash";

const MainHeading = styled(Typography)`
  font-weight: 600;
  font-size: 20px;
  line-height: 33px;
  color: #02a0fc;
`;

const Heading = styled(Typography)`
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  align-self: center;
`;

const DpCount = styled(Typography)`
  color: #333;
  font-weight: 400;
  font-size: 13px;
`;

const PercentageSlider = styled(Slider)({
  color: "#fff",
  height: 8,
  "& .MuiSlider-track": {
    border: "none",
    background: "#02a0fc",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid #02a0fc",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&:before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 50,
    height: 32,
    backgroundColor: "#02a0fc",
  },
});

export default function FormTwo({
  fields,
  formikProps,
  editState,
  location,
  languages,
  mandatoryFalseCount,
  percentageSliderValue,
  count,
  setPercentageSliderValue,
  oldMandatoryFalseCount,
  setOldMandatoryFalseCount,
}) {
  function handleSliderChange(e) {
    setPercentageSliderValue(e.target.value);

    formikProps.setValues((prev) => ({
      ...prev,
      percentage: { value: e.target.value },
    }));
  }

  function handleTextChange(event) {
    const {
      target: { value, name },
    } = event;
    let objectName = name.substring(0, name.indexOf("."));
    const name1 = name.split(".");

    formikProps.setValues((prevVal) => ({
      ...prevVal,
      [objectName]: setValues(prevVal[objectName]),
      dirty: true,
      // percentage: setPercentage(prevVal.percentage),
    }));

    function setValues(val) {
      if (typeof name[name1] === "string") {
        val.mandatory = true;
        val.value = value;
      } else {
        set(val, name.substring(name.indexOf(".") + 1), value);
        if (!val.value.min) {
          val.mandatory = false;
        }
      }

      return val;
    }
  }

  return (
    <Paper>
      <Grid item xs={12}>
        <MainHeading>Audience Preferences</MainHeading>
      </Grid>

      {fields.map(
        (field, index) =>
          index % 2 !== 0 && (
            <Fragment>
              <Grid item xs={6}>
                <Label
                  title={field.label}
                  formikProps={formikProps}
                  name={field.name}
                />
              </Grid>

              <Grid
                item
                xs={4}
                textAlign="end"
                style={{ display: "flex", justifyContent: "end" }}
              >
                <Heading
                  style={{
                    color: formikProps.values[field.name]?.mandatory
                      ? "red"
                      : "gray",
                  }}
                >
                  Mandatory
                </Heading>

                <Checkbox
                  disabled={
                    field.control_id === 3
                      ? !formikProps.values[field.name]?.value.min ||
                        !formikProps.values[field.name]?.value.max ||
                        !editState
                      : !editState ||
                        !formikProps.values[field.name]?.value ||
                        formikProps.values[field.name]?.value.length === 0
                  }
                  name={`${field.name}.mandatory`}
                  onChange={handleCheckChange}
                  checked={formikProps.values[field.name]?.mandatory}
                  icon={<ToggleOffOutlined fontSize="large" />}
                  checkedIcon={
                    <ToggleOnOutlined
                      fontSize="large"
                      style={{ color: "red" }}
                    />
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <DpCount>
                  {formikProps.values[field.name]?.userCount > 0 &&
                    `${formikProps.values[field.name]?.userCount.toFixed(
                      2
                    )} Million Users`}
                </DpCount>
              </Grid>

              {field.control_id === 3 && (
                <Grid item xs={10}>
                  <TextField
                    formikProps={formikProps}
                    name={`${field.name}.value`}
                    placeholder={field.label}
                    inputProps={{ "aria-label": "Without label" }}
                    disabled={!editState}
                  />
                </Grid>
              )}

              {field.control_id === 1 && (
                <Fragment>
                  <Grid item xs={5}>
                    <TextField
                      formikProps={formikProps}
                      onChange={handleTextChange}
                      name={`${field.name}.value.${field.options[0]["value"]}`}
                      placeholder={field.options[0].label}
                      inputProps={{ "aria-label": "Without label" }}
                      disabled={!editState}
                    />
                  </Grid>

                  <Grid item xs={5}>
                    <TextField
                      formikProps={formikProps}
                      onChange={handleTextChange}
                      name={`${field.name}.value.${field.options[1]["value"]}`}
                      placeholder={field.options[1].label}
                      inputProps={{ "aria-label": "Without label" }}
                      disabled={!editState}
                    />
                  </Grid>
                </Fragment>
              )}

              {field.control_id === 2 && field.multi_select && (
                <Grid item xs={10}>
                  <AutocompleteMultiSelect
                    forcePopupIcon={!editState ? false : true}
                    name={`${field.name}.value`}
                    formikProps={formikProps}
                    disabled={!editState}
                    defaults={{
                      primaryKey: "value",
                      displayLabel: "label",
                    }}
                    options={field.options}
                    placeholder={field.placeholder}
                    onChange={(_, arr, reason, detail) =>
                      handleChange(
                        arr,
                        detail,
                        reason,
                        `${field.name}.value`,
                        "value",
                        field.options
                      )
                    }
                  />
                </Grid>
              )}

              {field.control_id === 2 && !field.multi_select && (
                <Grid item xs={10}>
                  <Autocomplete
                    forcePopupIcon={!editState ? false : true}
                    name={`${field.name}.value`}
                    placeholder={field.placeholder}
                    defaults={{
                      primaryKey: "value",
                      displayLabel: "label",
                    }}
                    sx={{
                      "& .MuiSvgIcon-root": {
                        display: !editState && "none",
                      },
                    }}
                    options={field.options}
                    disabled={!editState}
                    onChange={(_, value, type) =>
                      handleChangeSingleSelect(value, type, field.name)
                    }
                    formikProps={formikProps}
                  />
                </Grid>
              )}

              {field.control_id === 4 && (
                <Grid item xs={10}>
                  <DesktopDatePicker
                    name={`${field.name}.value`}
                    formikProps={formikProps}
                    disabled={!editState}
                    inputProps={{ "aria-label": "Without label" }}
                    value={formikProps.values[field.name]?.value}
                    onChange={(newValue) => {
                      let date = new Date(newValue);

                      if ((date.getFullYear() + "").length < 3) {
                        return formikProps.setValues((prevVal) => ({
                          ...prevVal,
                          [field.name]: {
                            mandatory: false,
                            userCount: 0,
                            value: null,
                          },
                        }));
                      }

                      let d =
                        date.getFullYear() +
                        "-" +
                        "0" +
                        (date.getMonth() + 1) +
                        "-" +
                        date.getDate();

                      formikProps.setValues((prevVal) => ({
                        ...prevVal,
                        [field.name]: {
                          ...prevVal[field.name],
                          value: d,
                        },
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        disabled={!editState}
                        name={`${field.name}.value`}
                        {...params}
                      />
                    )}
                  />
                </Grid>
              )}
            </Fragment>
          )
      )}
      <Grid item xs={10}>
        <Label title={"Non mandatory match percentage"} />
      </Grid>

      <Grid item xs={10}>
        <PercentageSlider
          step={1}
          marks
          disabled={!editState}
          valueLabelDisplay="on"
          value={formikProps.values.percentage.value}
          min={0}
          max={mandatoryFalseCount}
          style={{ color: "#808080" }}
          onChange={handleSliderChange}
        />
      </Grid>
    </Paper>
  );
  function handleChangeSingleSelect(value, type, name) {
    function setValue(val) {
      val = {
        ...val,
        value: value.value,
      };

      return val;
    }
    if (type === "selectOption") {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        [name]: setValue(prevVal[name]),
      }));
    } else {
      value = {
        value: "",
        label: "",
      };

      formikProps.setValues((prevVal) => ({
        ...prevVal,
        [name]: setValue(prevVal[name]),
      }));
    }
  }

  function handleChange(arr, { option }, reason, name, displayName, options) {
    let objectName = name.substring(0, name.indexOf("."));

    formikProps.setValues((prevVal) => ({
      ...prevVal,
      [objectName]: setValuesOfDropDown(prevVal[objectName]),
    }));

    function setValuesOfDropDown(val) {
      let values = [...val.value];
      let count = val.userCount;
      let mandatory = val.mandatory;

      if (reason === "removeOption") {
        if (option?.value) {
          values = [...values.filter((items) => items !== option?.value)];
        } else {
          values.pop();
          option = options.filter((item) => item?.label === option)[0];
        }

        count = count - option?.count;
      }
      if (reason === "selectOption") {
        values.push(option[displayName]);
        count = count + option.count;
      }

      if (values.length === 0) {
        mandatory = false;
      }

      return {
        ...val,
        value: values,
        userCount: count,
        mandatory: mandatory,
      };
    }
  }

  function handleCheckChange(e) {
    const { name } = e.target;
    const objectName = name.substring(0, name.indexOf("."));

    formikProps.setValues((prevVal) => ({
      ...prevVal,
      [objectName]: setValues(prevVal[objectName]),
      percentage: setPercentage(prevVal.percentage),
      dirty: true,
    }));

    function setPercentage(percentage) {
      let p = percentage.value;

      if (
        mandatoryFalseCount <= percentageSliderValue &&
        Boolean(formikProps.values.ID)
      ) {
        if (p === percentageSliderValue && p === mandatoryFalseCount) {
          count.current = false;
        }

        if (!e.target.checked) {
          setPercentageSliderValue(mandatoryFalseCount);
          p = mandatoryFalseCount;
        } else {
          p = p - 1;
        }
      }

      if (
        mandatoryFalseCount < oldMandatoryFalseCount &&
        oldMandatoryFalseCount === percentageSliderValue &&
        !Boolean(formikProps.values.ID)
      ) {
        setPercentageSliderValue(mandatoryFalseCount);
        p = mandatoryFalseCount;
      }
      setOldMandatoryFalseCount(mandatoryFalseCount);

      return { ...percentage, value: p };
    }

    function setValues(val) {
      return { ...val, mandatory: e.target.checked };
    }
  }
}
